module.exports = __webpack_public_path__ + "img/loadingIconIOS.178902bf.svg";